import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface ToolLabelConfigurationResponse {
  success: boolean;
  is_protected: boolean;
  approver_role_id: number | null;
}

export const useToolLabelConfiguration = (labelId: number | null | undefined, enabled = true) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery<ToolLabelConfigurationResponse>({
    queryKey: ["tool-label-configuration", labelId],
    queryFn: async () => {
      if (!labelId) {
        throw new Error("Missing label ID");
      }
      const response = await fetch(ENDPOINTS.tool_registry.label_configuration(labelId), {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(response);
    },
    enabled: enabled && !!labelId && !!userToken,
  });
};
